import { render } from "./InsightTrigger.vue?vue&type=template&id=0e6ed959&scoped=true"
import script from "./InsightTrigger.vue?vue&type=script&lang=ts"
export * from "./InsightTrigger.vue?vue&type=script&lang=ts"

import "./InsightTrigger.vue?vue&type=style&index=0&id=0e6ed959&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0e6ed959"

export default script